<li class="nav-item pr-4 pl-3">
    <a class="bs-nav-link" (click)="logout()">
        <i class="fa fa-sign-out"></i> {{'Log Out' | translate: locale | async}}
    </a>
</li>
